// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.client

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.client.LocalSharedData
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.wallet.client.WalletClientSignedInUser
import org.multipaz.cbor.toDataItem
import org.multipaz.cbor.Bstr
import org.multipaz.wallet.client.toDataItem
import org.multipaz.wallet.client.WalletClientSignedInUser_fromDataItem

internal fun LocalSharedData.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "ol3u03w7HECAAdp0QkQoXKtZuzZLdKt8E7WmY7otjvY")
internal val LocalSharedData_cborSchemaId = ByteString(-94, 93, -18, -45, 124, 59, 28, 64, -128, 1, -38, 116, 66, 68, 40, 92, -85, 89, -69, 54, 75, 116, -85, 124, 19, -75, -90, 99, -70, 45, -114, -10)

internal fun LocalSharedData.Companion.fromCbor(data: ByteArray): LocalSharedData {
    return LocalSharedData.fromDataItem(Cbor.decode(data))
}

internal val LocalSharedData.Companion.cborSchemaId: ByteString
    get() = LocalSharedData_cborSchemaId

internal fun LocalSharedData.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("signedInUser", this.signedInUser.toDataItem())
    builder.put("dataVersion", this.dataVersion.toDataItem())
    builder.put("decryptedData", Bstr(this.decryptedData.toByteArray()))
    return builder.end().build()
}

internal fun LocalSharedData.Companion.fromDataItem(dataItem: DataItem): LocalSharedData {
    val signedInUser = WalletClientSignedInUser_fromDataItem(dataItem["signedInUser"])
    val dataVersion = dataItem["dataVersion"].asNumber
    val decryptedData = ByteString(dataItem["decryptedData"].asBstr)
    return LocalSharedData(
        signedInUser = signedInUser,
        dataVersion = dataVersion,
        decryptedData = decryptedData,
    )
}
